import anObject$1 from './an-object.js';
import isObject$1 from './is-object.js';
import './new-promise-capability.js';
import { __exports as newPromiseCapability$1 } from '../../../../../../_virtual/new-promise-capability.js';

var anObject = anObject$1;
var isObject = isObject$1;
var newPromiseCapability = newPromiseCapability$1;

var promiseResolve = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

export { promiseResolve as default };
